import {
  ClockRefresh,
  FileCheck03,
  FileDownload04,
  FileNew01,
  Review,
} from '@/components/Icons'
import { DocumentStatus } from '@/schema'

export function getStatusIcon(status: DocumentStatus) {
  switch (status) {
    case DocumentStatus.NEW:
      return <FileNew01 className="h-3 w-3" />
    case DocumentStatus.IN_REVIEW:
      return <Review className="h-3 w-3" />
    case DocumentStatus.APPROVED:
      return <FileCheck03 className="h-3 w-3" />
    case DocumentStatus.QUERY_RAISED:
      return <ClockRefresh className="h-3 w-3" />
    case DocumentStatus.UNDER_REVISION:
      return <FileDownload04 className="h-3 w-3" />
    default:
      return <FileNew01 className="h-3 w-3" />
  }
}

export function getStatusLabel(status: DocumentStatus): string {
  switch (status) {
    case DocumentStatus.NEW:
      return 'New'
    case DocumentStatus.IN_REVIEW:
      return 'In Review'
    case DocumentStatus.APPROVED:
      return 'Approved'
    case DocumentStatus.QUERY_RAISED:
      return 'Query Raised'
    case DocumentStatus.UNDER_REVISION:
      return 'Under Revision'
    default:
      return 'Unknown'
  }
}
